import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.SCHEDULE}/v1`;

async function fetch() {
  try {
    let response = await api.get(`${basePath}/ScheduleFile/scheduleTypeId?scheduleTypeId=all`);
    let treated = errorHandling.handleResponse(
      response,
      "importTypeService.fetch"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "importTypeService.fetch");
    return null;
  }
}

export const importTypeService = {
  fetch
};
